import React from 'react';
import { useNotificationsContext } from '../../../contexts/NotificationsContext';
import AuthNotification from './AuthNotification';

export interface INotificationsProps {
    section?: 'login' | 'signup' | 'modal' | 'social';
}

/**
 * This component can be used independently of the forms and the context may not be properly provided.
 * Adding some conditional checks to prevent a hard failure.
 * TODO: review if we need to trigger some console warnings to get the developer attention on the missing config.
 */
const Notifications = ({}: INotificationsProps) => {
    const notificationsContext = useNotificationsContext();

    return (
        <AuthNotification
            notificationMessage={
                notificationsContext?.state?.generalNotification ?? ''
            }
        />
    );
};

export default Notifications;
